import { Box, LinearProgress } from '@material-ui/core';
import Sidebar from 'components/organismos/Sidebar';
import React, { Suspense, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { getReservationInquiryCountApi } from 'api/inquiryApi';
import { saveReservationInquiryAmountSideBar } from 'redux/reservationInquiryAmount/actions';
import { privateRoutes } from 'router/routes';
// import useQuery from 'hooks/useQuery';
import { PrivateRouteType } from 'router/type';


/**
 * Sidebar on the left.
 * All pages are rendered on the right.
 * Used in PrivateRoute.
 */
const SidebarWrapperTemplate: React.FC = ({ children }) => {
  const { companyCode } = useParams<{ companyCode: string }>();
  const location = useLocation();
  const dispatch = useDispatch();
  const pathCurrent = location.pathname.replace(`/${companyCode}`, '');

  useEffect(() => {
    getReservationInquiryCountApi().then((res) => {
      const { unregisteredCount = 0 } = res || {};
      dispatch(saveReservationInquiryAmountSideBar({ unregisteredAmount: unregisteredCount }));
    }).catch((error) => {
      console.log(error);
    });
  }, [location.pathname, dispatch]);
  const privateRoutesFull = privateRoutes?.reduce((arrRoute:PrivateRouteType[], item:PrivateRouteType) => {
    if (item?.subRoutes) {
      const arrRouteSub = item?.subRoutes?.map((itemSub) => ({ ...itemSub, path: `${item?.path}${itemSub?.path}` }));
      return [...arrRoute, ...arrRouteSub, item];
    }
    return [...arrRoute, item];
  }, []);
  const pageWithoutSidebar = privateRoutesFull.filter((route) => route.hasAppbar === false || route.hasNotSidebar).map((r) => r.path);// url of page

  return (
    <Box display="flex">
      {(pageWithoutSidebar.includes(pathCurrent) || pathCurrent.includes('/applicationDocument/print')
       || pathCurrent.includes('/pos/adjusting/printslip') || pathCurrent.includes('/pos/adjusting/printslipDetail')) ? <></> : <Sidebar />}
      <Suspense fallback={<LinearProgress />}>
        {children}
      </Suspense>
    </Box>
  );
};

export default SidebarWrapperTemplate;
